import axios from 'axios'

const state = {
  userSetting: null
}

const actions = {
  LOAD_USER_SETTING: async ({commit}, userId) => {
    let {data} = await axios.get('user-settings', {
      params: {
        user_id: userId
      }
    })
    if (!data.error) {
      commit('SET_USER_SETTING', data.user_setting)
    }
  },
  UPDATE_USER_SETTING: async ({commit}, submitData) => {
    const url = 'user-settings/' + submitData.id
    let {data} = await axios.put(url, submitData.formData)
    if (!data.error) {
      console.log('success')
    }
  }
}

const mutations = {
  SET_USER_SETTING: (state, data) => {
    state.userSetting = data
  }
}

const getters = {
  getState: state => {
    return state
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.setting.js